<template>
  <div class="menu-wrapper">
    <div v-if="isMobile" class="d-flex flex-column fill-height pa-6 white">
      <div class="d-flex align-center justify-space-between mb-8">
        <div class="text-h6 font-weight-bold grey--text text--darken-3">
          <!-- Menu -->
        </div>
        <v-btn icon @click="closeDrawer" color="grey darken-1">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="mb-8 text-center">
        <div
          class="text-h5 font-weight-bold deep-purple--text text--accent-3 mb-1"
        >
          Happy Harbour
        </div>
        <div class="caption grey--text">The Celebrations Café</div>
      </div>

      <div class="d-flex flex-column">
        <v-btn
          v-for="(item, i) in menuItems"
          :key="i"
          :to="item.to"
          text
          large
          class="justify-start mb-2 text-capitalize text-body-1 font-weight-medium"
          active-class="deep-purple--text text--accent-3 bg-soft-purple"
          @click="closeDrawer"
        >
          {{ item.text }}
        </v-btn>

        <v-btn
          :to="{ name: 'BookNow' }"
          large
          class="mt-4 rounded-xl gradient-btn white--text"
          elevation="4"
          @click="closeDrawer"
        >
          Book Now
        </v-btn>
      </div>
    </div>

    <div v-else class="d-flex align-center justify-center">
      <v-btn
        v-for="(item, i) in menuItems"
        :key="i"
        :to="item.to"
        text
        rounded
        class="mx-1 text-capitalize subtitle-2 font-weight-bold grey--text text--darken-2 nav-btn"
        active-class="deep-purple--text text--accent-3 bg-soft-purple"
      >
        {{ item.text }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppMenu",
  computed: {
    isMobile() {
      // Accessing your store as per your original code
      return this.$store.state.isMobile;
    },
  },
  data() {
    return {
      // Centralized Menu Data
      menuItems: [
        { text: "About Us", to: { name: "HomeView", hash: "#about-us" } },
        { text: "Our Spaces", to: { name: "HomeView", hash: "#our-space" } }, // Renamed from 'Theaters' to match section ID
        {
          text: "Reviews",
          to: { name: "HomeView", hash: "#customer-reviews" },
        },
        { text: "Contact", to: { name: "HomeView", hash: "#contact-us" } },
      ],
    };
  },
  methods: {
    closeDrawer() {
      this.$emit("closeDrawer");
    },
  },
};
</script>

<style scoped>
/* Soft Background for Active State */
.bg-soft-purple {
  background-color: #f3e5f5 !important; /* deep-purple lighten-5 */
}

/* Desktop Nav Button Hover */
.nav-btn {
  letter-spacing: 0.5px;
  transition: all 0.2s ease-in-out;
}

.nav-btn:hover {
  background-color: #f5f5f5; /* grey lighten-4 */
  color: #6200ea !important; /* deep-purple accent-3 */
}

/* Gradient Button for Mobile */
.gradient-btn {
  background: linear-gradient(45deg, #6200ea, #9575cd);
  font-weight: 700;
  letter-spacing: 1px;
}
</style>
